import React from "react";

export default function Loading(props) {
  return <>{props.isLoading ? <h5></h5> : <> {props.children} </>}</>;
}
